import * as React from 'react';
export const DroppableContext = React.createContext({
    zone: 'defaultDroppableZone',
    droppableId: 'defaultDroppableId'
});
//# sourceMappingURL=DroppableContext.js.map